import React from 'react';
import { Link } from 'react-router-dom';
import AdPlaceholder from '../AdPlaceholder';
import { COZY_HUB_GAMES } from '../../data/cozyHubGames';
import './Footer.css';

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-ad">
          <AdPlaceholder variant="footer" />
        </div>
        <div className="footer-links">
          <Link to="/how-to-play">How to play</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/about">About</Link>
          <Link to="/feedback">Feedback</Link>
          <Link to="/apps">Get the app</Link>
          <Link to="/leaderboard">Leaderboard</Link>
          <Link to="/">Home</Link>
          {COZY_HUB_GAMES.map((game) => (
            <Link key={game.path} to={game.path}>
              {game.name}
            </Link>
          ))}
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </div>
        <p className="footer-copy">© {new Date().getFullYear()} Letter Quest. Play with words.</p>
      </div>
    </footer>
  );
}
